import useT from '@hooks/useTranslation'
import mix from '@utils/styles/mix'

import styles from './CardWatchButton.module.css'

// Serce obserwowania na karcie ogłoszenia (pole dotyku 44 px nad zdjęciem, ikona maską CSS). HTML z serwera;
// kliknięcie i stan obsługuje jeden WatchController na stronie.
export default function CardWatchButton ({ className, id, size, title, type }) {
    const watch = useT('Obserwuj')

    return (
        <button
            aria-label={`${watch}: ${title}`}
            aria-pressed="false"
            className={mix([styles.fav, size === 'sm' && styles.sm, className])}
            data-watch={id}
            data-watch-type={type}
            type="button"
        >
            <span />
        </button>
    )
}
